import PostLayout from "./PostLayout";

export default PostLayout;
